const Spacing = {
  none: 0,
  normal: 24,
  xxsmall: 4,
  xsmall: 8,
  small: 16,
  medium: 32,
  large: 40,
  xlarge: 48,
  xxlarge: 62,
  pagePadding: 18,
};

export default Spacing;
